import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=7dad8d96&scoped=true&lang=html&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dad8d96",
  null
  
)

export default component.exports